import { useQuery } from '@tanstack/react-query';
import { getSMSConversationMessages } from 'services/api/getSMSData';
import { queryKeys } from '../queryKeys';

export const useGetSMSConversationMessages = (conversationId?: string, isEnabled = false) => {
    const { data, isLoading, isFetching, ...rest } = useQuery({
        queryKey: queryKeys.smsConversationMessages(conversationId || ''),
        queryFn: () => getSMSConversationMessages({ conversationId: conversationId || '' }),
        enabled: !!(conversationId && isEnabled),
    });

    return {
        smsConversationMessages: data,
        isSMSConversationMessagesLoading: isLoading,
        isSMSConversationMessagesFetching: isFetching,
        ...rest,
    };
};
